<template>
  <card>
    <list
      v-if="$store.state.user.sections['system_keys']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "dealer",
      fields: [
        {
          col: " col-12 col-md-6",
          key: "system",
          label: "Выберите систему",
          type: "select",
          modal: "system",
          selectKey: "name",
        },
        {
          col: "col-12 col-md-6",
          label: "PARTNER ID",
          key: "key",
          type: "field",
        },
        {
          col: " col-12 col-md-12",
          key: "model_type",
          label: "Модель",
          type: "static_radio",
          items: [{ id: "shop", title: "Торговые точки" }],
        },

        {
          col: " col-12 col-md-12",
          key: "model",
          label: "Выберите модель",
          type: "select",
          modal: "shop",
          selectKey: "name",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_system_key",
      itemLink: "system_keys",
      setLink: "system_keys",
      columns: [
        {
          key: "system",
          title: "Система",
          object: "name",
          checkbox: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "key",
          title: "PARTNER ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "model_type",
          title: "Модель",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "model_id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "model",
          title: "Объект",
          object: "name",
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
